function getSearchURLParams(url)
{
    if(typeof url !== "string") {
        return {};
    }
   var urlSplit = url.split("?");
   if(urlSplit.length < 2) {
       return {};
   }
   return _.object(_.map(urlSplit[1].split("&"), function(params) {
       return params.split("=");
   }));
}
var jQuery = require("jQuery");
function getSuitelet(script, deploy) {
   return {"customscript_ns_sc_ext_sl_sn_sub:customdeploy_create_subscription":"/app/site/hosting/scriptlet.nl?script=3043&deploy=1&compid=543925&ns-at=AAEJ7tMQ-W5h-82lbrHKTQVKrc2uHzQyaOcQZjzx_aVoA5S9Ntc","customscript_ns_sc_sl_contact_us_form:customdeploy_ns_sc_sl_contact_us_form":"/app/site/hosting/scriptlet.nl?script=1148&deploy=1&compid=543925&ns-at=AAEJ7tMQ3SLT3G8DnpOXmwAefXepATuCcKQ0JFMwn4pR-qXVzaE","customscript_ns_sc_sl_id_isb:customdeploy_ns_sc_sl_id_isb":"/app/site/hosting/scriptlet.nl?script=3280&deploy=1&compid=543925&ns-at=AAEJ7tMQBt_M8vsYQbMDlp-j4vWrvfV8Tz0G_spMBbKZZCr20Cw","customscript_ns_sc_sl_inventory_display:customdeploy_ns_sc_sl_inventory_display":"/app/site/hosting/scriptlet.nl?script=1169&deploy=1&compid=543925&ns-at=AAEJ7tMQn3UfhhPELdoP-J2LivncBXtAfUFsHHwjqx9dvKkU6fk","customscript_ns_sc_sl_productleadtime:customdeploy_ns_sc_sl_productleadtime":"/app/site/hosting/scriptlet.nl?script=1150&deploy=1&compid=543925&ns-at=AAEJ7tMQvd-bdGhOqEXfcXqIUKiqVInQJrP9ZPMOj78fq5j3z5c","customscript_ns_sc_sl_sn_get_subs:customdeploy_ns_sc_sl_sn_get_subs":"/app/site/hosting/scriptlet.nl?script=3042&deploy=1&compid=543925&ns-at=AAEJ7tMQedm7vEj7Z_wbL35u5-5ps58lT-udQD0evbdnNQTBgy0","customscript_ns_sc_sl_sn_isb:customdeploy_ns_sc_sl_sn_isb":"/app/site/hosting/scriptlet.nl?script=3279&deploy=1&compid=543925&ns-at=AAEJ7tMQRDvrCYseBErk2gJxNwI3uQ5DtOjCADxEe56P8tGi9PM","customscript_ns_sc_sl_sn_subswitch:customdeploy_ns_sc_sl_sn_subswitch":"/app/site/hosting/scriptlet.nl?script=3041&deploy=1&compid=543925&ns-at=AAEJ7tMQbkS7l2jd8zM_LskjCyPhYXlwK_kQwKCmoUKnW3lYZHg"}[script + ":" + deploy];
}
var xhrFactory = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function() {
   var xhr = xhrFactory.apply(this, arguments);
   var open = xhr.open;
   xhr.open = function () {
        var url = arguments[1];
        var assocParams = getSearchURLParams(url);
        if(assocParams.hasOwnProperty("script") && assocParams.hasOwnProperty("deploy")) {
            var hashed = getSuitelet(assocParams["script"], assocParams["deploy"]);
            if(hashed) {
                var hashedParams = getSearchURLParams(hashed);
                var keys = Object.keys(assocParams);
                for (var i=0; i<keys.length; i++) {
                    var key = keys[i];
                    var value = assocParams[key];
                    if(!hashedParams.hasOwnProperty(key))
                    {
                        hashed += "&" + key + "=" + value;
                    }
                }
                arguments[1] = hashed;
            }
        }
        return open.apply(this, arguments);
    }
    return xhr;
}